export type EnvironmentConfig = {
  readonly OIDC_CLIENT: string
  readonly OIDC_URL: string
  readonly OIDC_MODE: string
  readonly FEED_URL: string
  readonly SENTRY_DSN: string
  readonly SENTRY_RELEASE: string
  readonly SENTRY_ENABLED: string
  readonly SENTRY_ENVIRONMENT: string
}

// biome-ignore lint/suspicious/noExplicitAny: window
export const environmentConfig: EnvironmentConfig = (globalThis as any)._env_
